import { SUPPORTABLE_FILES } from './constants';
import { getFileExtension } from './extension/helpers';
export const validateFiles = (files, { maxFiles, maxFileSize, supportedFileTypes = SUPPORTABLE_FILES, maxTotalFilesSizeBytes, }) => {
    if (files.length > maxFiles) {
        return {
            valid: false,
            message: `You can only select up to ${maxFiles} files.`,
        };
    }
    const extensions = files.map((i) => getFileExtension(i));
    const unsupportedExt = extensions.find((ext) => !supportedFileTypes.includes(ext ?? ''));
    if (unsupportedExt) {
        return {
            valid: false,
            message: `${unsupportedExt} files are not supported, please select another file`,
        };
    }
    const filesExceedMaxSize = files.filter((file) => file.size >= maxFileSize);
    if (filesExceedMaxSize.length > 0) {
        return {
            valid: false,
            message: `File size cannot exceed ${(maxFileSize / 1024 / 1024).toFixed(2)} MB limit.`,
        };
    }
    if (maxTotalFilesSizeBytes) {
        const totalSize = files.reduce((acc, file) => acc + file.size, 0);
        if (totalSize >= maxTotalFilesSizeBytes) {
            return {
                valid: false,
                message: `Total attachments size exceeds ${(maxTotalFilesSizeBytes / 1024 / 1024).toFixed(2)} MB. Please select a smaller file(s).`,
            };
        }
    }
    return { valid: true, message: '' };
};
